import { CircularProgress } from "@mui/material";
import Lottie from "react-lottie"; // Import Lottie component
import loadingAnimation from "../../assets/Lotties/ZinancialLoader.json"; // Your Lottie JSON file.
import { useEffect, useRef, useState } from "react";

const LoaderWrapper = ({ isLoading, children, size = "20px", fullWidth }) => {
  const parentRef = useRef(null);
  const [parentWidth, setParentWidth] = useState(0);
  const [parentHeight, setParentHeight] = useState(0);
  const [loaderWidth, setLoaderWidth] = useState("20px");

  useEffect(() => {
    if (parentRef.current) {
      const parentRect = parentRef?.current?.parentElement?.getBoundingClientRect();
      const parentWidth = parentRect.width;
      const parentHeight = parentRect.height;

      setParentHeight(parentHeight);
      setParentWidth(parentWidth);

      if (fullWidth) {
        setLoaderWidth(`${parseInt(parentHeight * 0.8)}px`);
      } else {
        setLoaderWidth(`${parseInt(parentWidth * 0.3)}px`);
      }
    }
  }, [isLoading]);

  const defaultOptions = {
    loop: true, // The animation will loop indefinitely
    autoplay: true, // The animation will autoplay
    animationData: loadingAnimation, // Lottie JSON animation
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <>
      {isLoading ? (
        <div
          ref={parentRef}
          className="relative w-full h-full flex items-center justify-center"
          style={{ height: `${parseInt(parentHeight)}px`, width: `${parseInt(parentWidth)}px` }}
        >
          <div
            className={`flex flex-col items-center justify-center gap-4`}
            //   style={{ width: !fullWidth && parentWidth, height: fullWidth && parentWidth }}
            style={{ width: loaderWidth }}
          >
            {/* <CircularProgress size={size} /> */}
            <Lottie options={defaultOptions} isClickToPauseDisabled />
          </div>
        </div>
      ) : (
        children
      )}
    </>
  );
};

export default LoaderWrapper;
